// extracted by mini-css-extract-plugin
export default {"content":"Nameadress_content__kf+c2","content__adress":"Nameadress_content__adress__PWwgX"};